<template>
  <div>
    <slot v-if="!!$slots.label || label"  name="label">
      <label :for="labelFor" :id="labelId" class="block text-sm font-bold">
        {{label}} <span v-if="mandatory">*</span>
      </label>
    </slot>
    <slot v-if="!!$slots.description || description" name="description">
      <span class="block text-sm text-grey-30">{{description}}</span>
    </slot>
    <slot>
      <!-- Input goes here -->
    </slot>
    <ErrorMessage :name="field" v-slot="{message}">
      <span role="alert" class="text-red mt-2 block">{{message}}</span>
    </ErrorMessage>
  </div>
</template>

<script>
import { ErrorMessage } from 'vee-validate'
export default {
  name: 'IntFormItem',
  
  components: {ErrorMessage},
  
  props: {
    labelId: { type: String },
    label: { type: String },
    fieldId: { type: String },
    field: { type: String, required: true },
    description: { type: String },
    mandatory: { type: Boolean, default: false }
  },
  
  data(){
    return {
      labelFor: this.fieldId || this.field
    }
  }
}
</script>